// extracted by mini-css-extract-plugin
export default {"container":"GroupControl-module__container___lHMHl","heading":"GroupControl-module__heading___ZGaz3","toggleIcon":"GroupControl-module__toggleIcon___O03CG"};